import React from 'react'
import { useLazyLoadQuery, graphql } from 'react-relay'
import { useLingui } from '@lingui/react/macro'

import { lazy as loadable } from '@loadable/component'

import { Metadata } from '@newComponents/Metadata'
import { wrapSuspenseScreen } from '@newComponents/SuspenseWrapper'
import { useScreenMessages } from '@data/i18n'

import { UnauthenticatedHomeScreen } from './UnauthenticatedHomeScreen/UnauthenticatedHomeScreen'

import { HomeScreenQuery } from './__generated__/HomeScreenQuery.graphql'

const AuthenticatedHomeScreen = wrapSuspenseScreen(
  loadable(() => import('./AuthenticatedHomeScreenNew'))
)

const HIGHLIGHTED_GUILD_SLUG =
  process.env.GUILD_ENV === 'production' ? 'gitnation' : 'gitnation'

export const HomeScreen = () => {
  useScreenMessages(
    (locale) =>
      import(
        /* webpackChunkName: "locale-home-screen-[request]" */ `./locales/${locale}.po`
      )
  )
  const { t } = useLingui()

  return (
    <>
      <Metadata
        title={t`Elevate Your Community`}
        description={t`Guild is the platform for communities. Attend an Event, catch a Presentation, and follow a Network!`}
      />

      <HomeScreenContent />
    </>
  )
}

const HomeScreenContent = () => {
  const data = useLazyLoadQuery<HomeScreenQuery>(
    graphql`
      query HomeScreenQuery($highlightedGuildSlug: String!) {
        viewer {
          id
        }

        ...UnauthenticatedHomeScreen_query
      }
    `,
    {
      highlightedGuildSlug: HIGHLIGHTED_GUILD_SLUG,
    }
  )

  if (data.viewer?.id) {
    return <AuthenticatedHomeScreen />
  }

  return <UnauthenticatedHomeScreen query={data} />
}

export default HomeScreen
